import React from 'react'
import OrdersDeliveredContainer from '../../../../Components/OrdersPart/OrdersDeliveredContainer/OrdersDeliveredContainer'
import Layout from '../../Layout'

const OrdersDelivered = () => {
  return (
    <Layout>
        <OrdersDeliveredContainer/>
    </Layout>
  )
}

export default OrdersDelivered